import { CALL_API, Schemas } from '../../common/middleware/api';

export const EMAIL_BOUNCES_REQUEST = 'EMAIL_BOUNCES_REQUEST';
export const EMAIL_BOUNCES_SUCCESS = 'EMAIL_BOUNCES_SUCCESS';
export const EMAIL_BOUNCES_FAILURE = 'EMAIL_BOUNCES_FAILURE';

export const EMAIL_BOUNCE_DELETE_REQUEST = 'EMAIL_BOUNCE_DELETE_REQUEST';
export const EMAIL_BOUNCE_DELETE_SUCCESS = 'EMAIL_BOUNCE_DELETE_SUCCESS';
export const EMAIL_BOUNCE_DELETE_FAILURE = 'EMAIL_BOUNCE_DELETE_FAILURE';

export const loadEmailBounces = (options) => ({
	[CALL_API]: {
		types: [EMAIL_BOUNCES_REQUEST, EMAIL_BOUNCES_SUCCESS, EMAIL_BOUNCES_FAILURE],
		endpoint: 'api/emailBounces',
		request: options,
		schema: Schemas.EMAIL_BOUNCES_ARRAY
	}
});

export const deleteEmailBounce = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [EMAIL_BOUNCE_DELETE_REQUEST, EMAIL_BOUNCE_DELETE_SUCCESS, EMAIL_BOUNCE_DELETE_FAILURE],
		endpoint: `api/emailBounces/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});